import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useParams } from 'react-router-dom'

// Actions
import { actions as usersActions } from 'modules/users/actions'
import { actions as collectionsActions } from 'modules/collections/actions'
import { actions as userSongActions } from 'modules/usersongs/actions'

// Components
import { Error, Spinner } from '@tracklib/kit'
import UserLayout from 'components/profile/userlayout'
import BeatList from 'components/beat/beatlist'
import Grid from 'components/collection/grid'
import SEO from 'components/base/seo'

// Hooks
import { useRequest } from 'modules/requests/hooks'
import { useUser } from 'modules/users/hooks'

// Types
import { Dispatch } from 'types'

export const loadInitialData =
  ({
    location: {
      params: { id },
    },
  }: {
    location: { params: { id: string } }
  }) =>
  async (dispatch: Dispatch) => {
    return Promise.all([
      dispatch(usersActions.fetchUser(+id)),
      dispatch(userSongActions.fetchBeatByUser(+id)),
      dispatch(collectionsActions.fetchCollections(`?owner=${+id}&size=12`)),
    ])
  }

const UserPage = () => {
  const dispatch = useDispatch()
  const { userId = '' } = useParams() as { userId: string }
  const user = useUser(userId)
  const fetchUserRequest = useRequest('FETCH_USER', String(userId))

  useEffect(() => {
    if (!user && !fetchUserRequest.isLoading && !fetchUserRequest.hasError && userId) {
      dispatch(usersActions.fetchUser(+userId))
    }
  }, [dispatch, userId, fetchUserRequest, user])

  if (!user) {
    if (fetchUserRequest.isDone) {
      return <Error />
    } else {
      return <Spinner minHeight={400} delay={0} />
    }
  }
  const title = `@${user.alias}, a user on Tracklib`
  const description = `@${user.alias} is a user on Tracklib`
  return (
    <>
      <SEO title={title} description={description} type="profile">
        <meta property="profile:username" content={user.alias} />
      </SEO>
      <UserLayout user={user}>
        <BeatList userId={user.id} />
        <Grid
          heading="Collections"
          searchQuery={`?owner=${userId}&size=12`}
          emptyStateTitle="No public collections"
          emptyStateSubtitle="This user has not made any of their collections public."
        />
      </UserLayout>
    </>
  )
}

export default UserPage
